/* eslint-disable */
import React from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { Stack, Card } from '@material-ui/core';
import _ from 'lodash';

export const GoodsInvoiceTable = ({ farmerData, res, key }) => {
    return (
        <>
            <Card key={key} sx={{ border: '2px solid black', width: '700px', borderRadius: "0" }}>
                <h5 style={{ marginLeft: '5px' }}>
                    {res.goodDetails[0].completedDate === "0001-01-01T00:00:00"
                        ? farmerData.currentDate
                        : new Date(res.goodDetails[0].completedDate).toLocaleString('en-GB', {
                            day: 'numeric',
                            month: 'numeric',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                        }).replace(',', '')}
                </h5>
                <h4><center>{farmerData.groupName}</center></h4>
                <h4><center>FCC - {farmerData.factoryName}</center></h4>
                <h4><center>Goods Receive Note</center></h4>
                <h4><center>----------------</center></h4>
                <div>&nbsp;</div>
                <Card sx={{ borderRadius: "0" }}>
                    <Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Date</h4>
                            <h4>{':'}</h4>
                            <h4 style={{ width: '220px' }}>{farmerData.orderDate.split('T')[0]}</h4>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Txn No</h4>
                            <h4>{':'}</h4>
                            <h4>{farmerData.invoiceNo == null ? '-' : farmerData.invoiceNo}</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Supplier</h4>
                            <h4>{':'}</h4>
                            <h4 style={{ width: '220px' }}>{farmerData.fullName}</h4>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Date</h4>
                            <h4>{':'}</h4>
                            <h4>{farmerData.orderDate.split('T')[0]}</h4>
                        </Stack>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice No</h4>
                            <h4>{':'}</h4>
                            <h4 style={{ width: '220px' }}>{farmerData.invoiceNo == null ? '-' : farmerData.invoiceNo}</h4>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Inv Amount</h4>
                            <h4>{':'}</h4>
                            <h4>{parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Order No</h4>
                            <h4>{':'}</h4>
                            <h4 style={{ width: '220px' }}>{farmerData.orderNo}</h4>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Type</h4>
                            <h4>{':'}</h4>
                            <h4>{farmerData.invoiceType == null ? "-" : farmerData.invoiceType == 4 ? "Credit" : "Cash"}</h4>
                        </Stack>
                    </Stack>



                    <TableContainer >
                        <Table size="small" aria-label="caption table">
                            <TableHead>
                                <TableRow sx={{ borderTop: '2px solid black', borderBottom: '2px solid black' }}>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>Item</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>Description</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>U Size</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>U Price</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Rec Qty</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align={'right'}>Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody sx={{ borderBottom: '2px solid black' }}>
                                {res.goodDetails.map((data, index) => (
                                    <TableRow sx={{ minHeight: "5px", height: "5px" }} key={index}>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'} >
                                            {data.productCode}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                                            <Stack direction={{ xs: 'column', sm: 'row' }}>
                                                {data.productName}
                                            </Stack>
                                            {data.isSpecialOrder == true ?
                                                <Stack direction={{ xs: 'column', sm: 'row' }} >
                                                    <h5 style={{ marginTop: '-5px' }}>{data.performOrderCode}</h5>
                                                </Stack> : null}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'left'}>
                                            {data.measuringUnit == 2 ? '1 KG' : '1 Unit'}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                            {parseFloat(data.realizedPrice).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                            {parseFloat(data.netAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }} align={'right'} >
                                            {parseFloat(data.totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Gross Total</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>{parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Discount</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Over Chg</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Not Supply</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Rounding Diff</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Adjustment</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>0.00</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4>------------------</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Invoice Value</h4>
                            <h4>:</h4>
                            <h4 style={{ width: '85px', textAlign: 'right', marginRight: '15px' }}>{parseFloat(farmerData.total).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</h4>
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                            <h4>============</h4>
                        </Stack>
                        <div>&nbsp;</div>
                        <Stack direction={{ xs: 'column', sm: 'row' }} >
                            <h4 style={{ marginLeft: '5px', width: '120px' }}>Prepared By</h4>
                            <h4 style={{ width: '120px' }}>------------------</h4>
                            <h4 style={{ marginLeft: '50px', width: '120px' }}>Checked By</h4>
                            <h4 style={{ width: '120px' }}>------------------</h4>
                        </Stack>
                    </Stack>
                    <div>&nbsp;</div>
                </Card>
            </Card>
        </>
    );
}